(function($) {
    $(function() {
        var $filterTrigger = $('.supapress-show-filters'),
            $filterTriggerText = $('.supapress-show-filters span'),
            $filters = $('.filter-wrapper');

        //Open the filters on mobile
        $filterTrigger.on('click', function() {
            $filters.toggleClass('open-filters');
            $filterTriggerText.text(function(i, text){
                return text === universityPressThemeSettings.search_mobile_open_text ? universityPressThemeSettings.search_mobile_close_text : universityPressThemeSettings.search_mobile_open_text;
            });
        });
    });
})(jQuery); 